import v4 from './v4.vue'

export default {
  v4
}
